import { render, staticRenderFns } from "./persistentvolumeclaim.vue?vue&type=template&id=1d43f100&scoped=true&"
import script from "./persistentvolumeclaim.vue?vue&type=script&lang=js&"
export * from "./persistentvolumeclaim.vue?vue&type=script&lang=js&"
import style0 from "./persistentvolumeclaim.vue?vue&type=style&index=0&id=1d43f100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d43f100",
  null
  
)

export default component.exports